import { formatDateTimeBs } from "@/lib/format";
import { Button } from "@/components/ui/button";
import type { DocumentVersionSummary } from "@/types";

interface VersionsPanelProps {
  versions: DocumentVersionSummary[];
  currentVersionId: string | null;
  onPreview: (versionId: string) => void;
}

export function VersionsPanel({ versions, currentVersionId, onPreview }: VersionsPanelProps) {
  return (
    <div className="rounded-lg border">
      <div className="border-b px-4 py-3 font-medium">Verzije</div>
      <ul className="divide-y">
        {versions.map((v) => (
          <li key={v.id} className="flex items-start justify-between gap-3 px-4 py-3">
            <div className="min-w-0">
              <div className="text-sm font-medium">
                v{v.version}
                {v.id === currentVersionId ? " (aktuelna)" : ""}
              </div>
              <div className="text-xs text-muted-foreground">{formatDateTimeBs(v.createdAt)}</div>
              {v.changeNote ? <div className="mt-1 text-xs">{v.changeNote}</div> : null}
            </div>
            <Button variant="ghost" size="sm" onClick={() => onPreview(v.id)}>
              PDF
            </Button>
          </li>
        ))}
      </ul>
    </div>
  );
}
